export default function Loader() {
  return (
    <div className="w-full h-screen flex flex-col items-center justify-center gap-4 bg-white">
      {/* Logo */}

      <div className="w-60 ">
        <img
          src="/images/logo.png"
          alt="HOA"
          className="h-full w-full object-cover animate-pulse [animation-duration:2.5s]"
        />
      </div>

      {/* Spinner */}
      <div className="w-12 h-12 border-4 border-gray-300 border-t-black rounded-full animate-spin"></div>
      <div className="text-2xl font-bold text-gray-800">Loading...</div>
    </div>
  );
}
